<app-special-investment-table
  [currentTabname]="tabName"
  [isPoeDoc]="isPoeDoc"
  [prevDocumentType]="prevDocumentType"></app-special-investment-table>
